import { pushToDataLayer } from '@domain-group/fe-helper';
import { sendToMixpanel } from '..';

export type CtaDriverProductType =
  | 'Home Price Guide'
  | 'Appraisal Funnel'
  | 'Recently Sold';

export interface CtaDriverTrackingProps {
  productType: CtaDriverProductType;
  interactionCTA: string;
  elementListPosition: number;
  elementTargetCategoryPrimary: string;
  elementTargetPageType: string;
  elementTitle: string;
}

const trackCtaDriver = ({
  productType,
  interactionCTA,
  elementListPosition,
  elementTargetCategoryPrimary,
  elementTargetPageType,
  elementTitle,
}: CtaDriverTrackingProps): void => {
  sendToMixpanel('Tap CTA Driver', {
    productType,
    interactionCTA,
  });

  pushToDataLayer({
    event: 'cta_driver',
    event_parameters: {
      element_list_name: 'Find an Agent CTA drivers',
      element_list_position: elementListPosition,
      element_target_category_primary: elementTargetCategoryPrimary,
      element_target_page_type: elementTargetPageType,
      element_text: interactionCTA,
      element_title: elementTitle,
      element_type: 'Widget',
    },
  });
};

export default trackCtaDriver;
